import PropTypes from 'prop-types';

const geoPropType = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
  }),
).isRequired;

const agePropType = PropTypes.shape({
  min_months: PropTypes.number,
  max_months: PropTypes.number,
}).isRequired;

export default {
  accessibility_options: PropTypes.arrayOf(PropTypes.string).isRequired,
  age_requirements: agePropType,
  age_specializations: agePropType,
  city_requirements: geoPropType,
  county_requirements: geoPropType,
  delivery_options: PropTypes.arrayOf(PropTypes.string).isRequired,
  eligibility_text: PropTypes.string,
  gender_requirements: PropTypes.arrayOf(PropTypes.string).isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  state_requirements: PropTypes.arrayOf(PropTypes.string).isRequired,
  population_specializations: PropTypes.arrayOf(PropTypes.string).isRequired,
  postal_code_requirements: PropTypes.arrayOf(PropTypes.string).isRequired,
  payment_options: PropTypes.arrayOf(PropTypes.string).isRequired,
  transportation_options: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export const defaultProgramProps = {
  eligibility_text: '',
};
